import { z } from 'zod';

/** Reusable query params for list endpoints. Coerces strings (query params are strings). */
export const PaginationQuery = z.object({
  page: z.coerce.number().int().positive().default(1),
  pageSize: z.coerce.number().int().positive().max(100).default(20),
  cursor: z.string().optional(),
});
export type PaginationQuery = z.infer<typeof PaginationQuery>;

export const SortQuery = z.object({
  sortBy: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).default('desc'),
});
export type SortQuery = z.infer<typeof SortQuery>;

export const SearchQuery = z.object({ q: z.string().trim().max(200).optional() });

/** Compose the common list query (pagination + sort + free-text search). */
export const ListQuery = PaginationQuery.merge(SortQuery).merge(SearchQuery);
export type ListQuery = z.infer<typeof ListQuery>;
